import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'

import {NotificationFilterType} from '@toolify/server/src/controllers/NotificationController/enum/NotificationFilterType'
import {INotificationPageStrategyItem} from '@toolify/client/src/modules/notifications/types/INotificationPageStrategyItem'
import {mapNotificationToItem} from '@toolify/client/src/stores/NotificationStore/singletons/mapNotificationToItem'

export abstract class DefaultNotificationStrategy<T extends NotificationType> implements INotificationTypeStrategy {
  abstract getBrowserNotification(
    notification: INotificationResponseInstance<T>,
    authorNick: string
  ): IBrowserNotification;

  getAffectedFilterTypes(notification: INotificationResponseInstance<T>): NotificationFilterType[] {
    return [
      NotificationFilterType.All,
      NotificationFilterType.Unread,
    ]
  }

  getPageStrategy(notification: INotificationResponseInstance<T>): INotificationPageStrategyItem {
    const notificationItem = mapNotificationToItem(notification)

    return {
      type: notification.type,
      payload: {
        notification,
        notificationItem,
        resourceRoute: notificationItem?.to ?? null,
      },
    } as INotificationPageStrategyItem
  }
}

